if (!customElements.get('product-form-redeem')) {
  customElements.define(
    'product-form-redeem',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

async onSubmitHandler(evt) {
  document.querySelector('.error_display').classList.remove('active');
   document.body.classList.add('checkout_btn_load');
  document.body.classList.remove('popup-error');
  evt.preventDefault();

  try {
    const response = await fetch('https://www.korres.com/cart?view=data');
    const data = await response.json();
const varId = this.submitButton.dataset.varid;
const drawerItems = Array.from(document.querySelectorAll('[cart-section="drawerredeem"]'));

const matchedItem = drawerItems.find(item => item.getAttribute('cart-var-id') === varId);

if (matchedItem) {
  console.log('Match found:', matchedItem);

  const quantityInput = matchedItem.querySelector('.quantity__input');
  if (quantityInput) {
    const value = parseInt(quantityInput.value, 10);
    const max = parseInt(quantityInput.dataset.maxi, 10);

    if (value < max) {
      console.log(`Quantity ${value} is within limit (${max})`);
    } else {
      console.log(`Quantity ${value} exceeds max limit (${max})`);
       document.querySelector('.error_display_text').innerHTML = 'Maximum redeem count reached.';
      document.querySelector('.error_display').classList.add('active');
        return; // Stop execution if count is less than 20
    }
  }
}

    if (data.customer < 1) {
      // document.querySelector('.error_display_text').innerHTML = 'In order to Redeem your Favorite Products you need to <a href="https://www.korres.com/account/login" target="_blank">Login</a>.';
      document.querySelector('.error_display_text').innerHTML = 'To redeem your favorites, please log in or sign up.';
      document.querySelector('.error_display').classList.add('active');
      document.body.classList.add('popup-error');
      return; // Stop execution if count is less than 20
    }

    if (data.count < 1) {
     document.querySelector('.error_display_text').innerHTML = 'Add at least one product in your shopping cart to start redeeming your points.';
      document.querySelector('.error_display').classList.add('active');
      document.body.classList.add('popup-error');
      return; // Stop execution if count is less than 20
    }
//    alert(data.redeemCount + " " + data.maxRedeem);
        if (data.redeemCount >= data.maxRedeem) {
     document.querySelector('.error_display_text').innerHTML = 'Maximum product limit reached';
      document.querySelector('.error_display').classList.add('active');
      document.body.classList.add('popup-error');
      return; // Stop execution if count is less than 20
    }
    const input = this.querySelector('input.redep[type="text"][name="properties[redeem_points]"]');
if (input) {
   const redeemValue = input.value;
if (data.totalAvailable < redeemValue) {
    document.querySelector('.error_display_text').innerHTML = 'Unfortunately you do not have enough Circle Points to redeem this product <a href="https://www.korres.com/collections/all-products" target="_blank">Earn More</a>.';
      document.querySelector('.error_display').classList.add('active');
      return; // Stop execution if count is less than 20
}
}
  } catch (error) {
    console.error('Error fetching cart data:', error);
    return; // Optional: prevent further execution if the fetch fails
  }

  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);
  if (this.cart) {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  try {
    const response = await fetch(`${routes.cart_add_url}`, config);
    const result = await response.json();

    if (result.status) {
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'product-form-redeem',
        productVariantId: formData.get('id'),
        errors: result.errors || result.description,
        message: result.message,
      });
      this.handleErrorMessage(result.description);

      const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      if (!soldOutMessage) return;
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButtonText.classList.add('hidden');
      soldOutMessage.classList.remove('hidden');
      this.error = true;
      return;
    } else if (!this.cart) {
      window.location = window.routes.cart_url;
      return;
    }

    if (!this.error) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form-redeem',
        productVariantId: formData.get('id'),
        cartData: result,
      });
    }

    this.error = false;

    const quickAddModal = this.closest('quick-add-modal');
    if (quickAddModal) {
      document.body.addEventListener(
        'modalClosed',
        () => {
          setTimeout(() => {
            this.cart.renderContents(result);
          });
        },
        { once: true }
      );
      quickAddModal.hide(true);
    } else {
      this.cart.renderContents(result);
    }

    // Re-initialize Flickity after updating cart
    initializeFlickity();
   redem_progress();
  } catch (e) {
    console.error(e);
  } finally {
    this.submitButton.classList.remove('loading');
    if (this.cart && this.cart.classList.contains('is-empty')) {
      this.cart.classList.remove('is-empty');
    }
    if (!this.error) {
      this.submitButton.removeAttribute('aria-disabled');
    }
    this.querySelector('.loading__spinner').classList.add('hidden');
    if (document.querySelector('.redemption_info')) {
  fetch('https://www.korres.com/cart?view=data')
    .then(response => response.json())
    .then(data => {
      const totalAvailable = Math.floor(data.totalAvailable); // Round down
      const prior = data.prior;

      // Update redemption point display
      const redemptionPointEl = document.querySelector('.redemption_point');
      if (redemptionPointEl) {
        redemptionPointEl.textContent = `$${totalAvailable}`;
      }

      // Update progress bar
      const progressEl = document.querySelector('.progress.prior');
      if (progressEl) {
        const widthPercent = Math.min(100, Math.round((prior / (totalAvailable || 1)) * 100));
        progressEl.style.width = `${widthPercent}%`;
        progressEl.setAttribute('data-width', `${widthPercent}%`);
      }
    })
    .catch(error => {
      console.error('Failed to fetch cart data:', error);
    });
}

  }

}

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form-redeem__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-redeem__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
